import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';

import MetaByCorpus from './MetaByCorpus.js';
import { H2 } from '@blueprintjs/core';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';

class Meta extends React.PureComponent {

  state = {
    selectedTabId: 'Global',  // select first corpus by default
  }

  handleTabChange = (navbarTabId) => this.setState({ selectedTabId: navbarTabId });

  render() {
    const { data, t} = this.props;
    if (Object.keys(data.subCorpora)) {
      const subCorpora=Object.keys(data.subCorpora).sort();
      const tabs = [];
      const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
      
      // building global corpus data
      const global={
        nbSents:0,
        nbDocs:0,
        nbToks:0,
        isOpen:1,
        docs:{},
      };
      // hash that contains the nbDocs and nbToks for each subCorpus
      const nbDocs={};
      const nbToks={};
      for (var i=0;i<subCorpora.length;i++) {
        const subCorpus=data.subCorpora[subCorpora[i]];
        global.nbSents+=subCorpus.nbSents;
        global.nbDocs+=subCorpus.nbDocs;      
        global.nbToks+=subCorpus.nbToks;
        global.isOpen*=subCorpus.isOpen;
        nbDocs[subCorpora[i]]=subCorpus.nbDocs;
        nbToks[subCorpora[i]]=subCorpus.nbToks;

        for (var key of Object.keys(subCorpus.docs)) {
          global.docs[key]=subCorpus.docs[key];
        }
      }
      const meta = <MetaByCorpus
          name={'Global'} 
          data={global}
          language={data.language} // use to open a reading page
          aligned_language={data.aligned_language} // use to open a reading page
          nbDocs={nbDocs}
          nbToks={nbToks}
      />;
      const tab = <Tab key={'Global'} id={'Global'} title={'Global'} panel={meta} />;
      tabs.push(tab);


      // generate the indidual stat pages (sub-corpus or partition) if necessary
      for (i=0;i<subCorpora.length;i++) {
        const subCorpus=subCorpora[i];
        const meta = <MetaByCorpus
                        name={subCorpus} 
                        data={data.subCorpora[subCorpus]}
                        language={data.language} // use to open a reading page
                        aligned_language={data.aligned_language} // use to open a reading page
                    />;
        const tab = <Tab key={subCorpus} id={subCorpus} title={subCorpus} panel={meta} />;
        tabs.push(tab);
      }

      return (
        <>
          <br/>
          <H2>{t('metadata')}</H2>
          <ul>
              <li>{t('tokenNumberColon')} { Intl.NumberFormat(langFormat).format(data.nbToks)}</li>
              { data.nbSents > 0 &&
                <li>{t('sentNumberColon')} { Intl.NumberFormat(langFormat).format(data.nbSents)}</li>
              }
              <li>{t('docNumberColon')} { Intl.NumberFormat(langFormat).format(data.nbDocs)}</li>
          
          </ul>
          <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
            {tabs}
          </Tabs>
        </>
      );
    }
  }
}

Meta.propTypes = {
  data: PropTypes.object,
};

export default withTranslation()(Meta);
